import { render } from "./subprp.vue?vue&type=template&id=70814819&scoped=true"
import script from "./subprp.vue?vue&type=script&lang=js"
export * from "./subprp.vue?vue&type=script&lang=js"

import "./subprp.vue?vue&type=style&index=0&id=70814819&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70814819"]])

export default __exports__